import { createColumnHelper } from '@tanstack/react-table';
import { EmailWhitelistConfiguration } from '@mews-commander/data-access';
import { lt, useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { IconButton, IconName } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { getLocalizedMailTypes } from '../helpers';
import { DeleteWhitelistedUserEmail } from './DeleteWhitelistedUserEmail';

const columnHelper = createColumnHelper<EmailWhitelistConfiguration>();

const renderMailTypes = (mailTypes: string[]): string => {
    const displayItems = 3;
    const visibleItems = mailTypes.slice(0, displayItems).join(`${UnicodeEntity.Comma} `);
    const remainingItems =
        mailTypes.length > displayItems ? ` ${UnicodeEntity.PlusSign}${mailTypes.length - displayItems}` : '';

    return visibleItems + remainingItems;
};

interface UseColumnsProps {
    onRowEdit: (id: string) => void;
}

export const useColumns = ({ onRowEdit }: UseColumnsProps) => {
    const localizeText = useLocalizeText();

    return [
        columnHelper.accessor('name', {
            id: 'fullName',
            header: () => lt(TextKey.Name),
            cell: (props) => props.getValue(),
            enableSorting: true,
        }),
        columnHelper.accessor('email', {
            id: 'email',
            header: () => lt(TextKey.Email),
            cell: (props) => props.getValue(),
        }),
        columnHelper.accessor('emailTypes', {
            id: 'emailGroups',
            header: () => lt(TextKey.WhitelistedUserEmailsTableHeaderEmailTypes),
            cell: (props) => {
                const localizedMailTypes = getLocalizedMailTypes({ localizeText, emailTypes: props.getValue() });
                return renderMailTypes(localizedMailTypes);
            },
        }),
        columnHelper.accessor('id', {
            header: () => null,
            meta: {
                align: 'end',
            },
            cell: (props) => (
                <>
                    <IconButton
                        variant="ghost"
                        icon={IconName.Edit}
                        onClick={() => onRowEdit(props.getValue())}
                        size="small"
                        type="submit"
                    />
                    <DeleteWhitelistedUserEmail
                        row={props.row.original}
                        renderButtonComponent={(onClick) => (
                            <IconButton
                                variant="ghost"
                                icon={IconName.Delete}
                                onClick={onClick}
                                size="small"
                                type="submit"
                            />
                        )}
                    />
                </>
            ),
        }),
    ];
};
